
import type { BaseErrorResponse, GetPeriodsRes, GetPeriodCloseHistoryRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function usePeriod() {
  class Period<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Period
     * @name PeriodControllerGetPeriods
     * @summary Getting a list of periods
     * @request GET:/api3/period
     * @secure
     * @response `200` `GetPeriodsRes`
     * @response `400` `BaseErrorResponse`
     */
    periodControllerGetPeriods = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPeriodsRes, BaseErrorResponse>({
        path: '/api3/period',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Period
     * @name PeriodControllerGetPeriodCloseHistory
     * @summary Getting a list of period closing history
     * @request GET:/api3/period/close-history
     * @secure
     * @response `200` `GetPeriodCloseHistoryRes`
     * @response `400` `BaseErrorResponse`
     */
    periodControllerGetPeriodCloseHistory = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPeriodCloseHistoryRes, BaseErrorResponse>({
        path: '/api3/period/close-history',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Period();
}
